var Backbone = require('backbone');
import CostCentreGroup from 'receipt/models/costcentregroup';

var CostCentreGroupCollection = Backbone.Collection.extend({
    model: CostCentreGroup
});

module.exports = CostCentreGroupCollection;


// WEBPACK FOOTER //
// ./receipt/collections/costcentregroup.js